import { Api } from '../api';
import { auth } from '../endpoints';
import type { AuthResponse } from './models';

export class AuthApi extends Api {
  static authenticate = async (userId: string): Promise<Omit<AuthResponse, 'acessToken'>> => {
    const response = await this.get<AuthResponse>({ url: auth.authenticate(userId) });
    const { acessToken, accessToken, ...data } = response;

    return { ...data, accessToken: acessToken || accessToken };
  };

  static refreshToken = async (refreshToken: string): Promise<Omit<AuthResponse, 'acessToken'>> => {
    const response = await this.post<unknown, AuthResponse>({ url: auth.refreshToken(refreshToken), headers: {} });
    const { acessToken, accessToken, ...data } = response;

    return { ...data, accessToken: acessToken || accessToken };
  };

  static impersonateUser = async (userId: string): Promise<Omit<AuthResponse, 'acessToken'>> => {
    const response = await this.post<unknown, AuthResponse>({ url: auth.onbehalf(userId) });
    const { acessToken, accessToken, ...data } = response;

    return { ...data, accessToken: acessToken || accessToken };
  };
}
